import { IUser } from "@/types/auth";
import axios, { AxiosResponse } from "axios";
import { create } from "zustand";

interface AuthResponse {
  code: number;
  error: boolean;
  message: string;
  data: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    token: string;
  };
  errors?: [];
}

interface useAuthStore {
  user?: IUser | null;

  signIn: (username: string, password: string) => Promise<void>
  signOut: () => Promise<void>
  fetchCurrentUser: () => Promise<void>
}

export const useAuth = create<useAuthStore>((set) => ({
  user: undefined,

  signIn: async (username: string, password: string): Promise<void> => {
    // TODO: implement login here
  },

  signOut: async (): Promise<void> => {
    // TODO: implement login here
  },

  fetchCurrentUser: async (): Promise<void> => {
    try {
      const response: AxiosResponse<AuthResponse> = await axios.get("auth/me")

      const { data } = response?.data

      if (data?.id) {
        set({ user: data })
        console.log("Current user data")
        console.log(data)
      } else {
        set({ user: null })
      }

    } catch (error: unknown) {
      set({ user: null })
    }
  }
}))



